import {
  Collection,
  roles,
  SocialNetworksData,
  UserData,
} from "../types/authTypes";
import { Subjects } from "../permission/constants";
import { Image } from "../services/shirts/types";

export class User {
  access_token: string | undefined;
  refresh_token: string | undefined;
  access_token_exp: string | undefined;
  refresh_token_exp: string | undefined;
  userId: number | undefined;
  userName: string | undefined;
  role: roles | undefined;
  email: string | undefined;
  profileImage: Image | undefined;
  headerImage: Image | undefined;
  userData: UserData | undefined;
  collection: Collection | undefined;
  social_networks: Array<SocialNetworksData>;
  item_count: number | undefined;

  static get modelName(): string {
    return Subjects.USER;
  }

  constructor(
    userId: number | undefined,
    access_token: string | undefined,
    userName: string | undefined,
    refresh_token: string | undefined,
    access_token_exp: string | undefined,
    refresh_token_exp: string | undefined,
    role: roles | undefined,
    email: string | undefined,
    profileImage: Image | undefined,
    headerImage: Image | undefined,
    userData: UserData | undefined,
    collection: Collection | undefined,
    social_networks: Array<SocialNetworksData>,
    item_count: number | undefined,
  ) {
    this.access_token = access_token;
    this.refresh_token = refresh_token;
    this.access_token_exp = access_token_exp;
    this.refresh_token_exp = refresh_token_exp;
    this.userId = userId;
    this.userName = userName;
    this.role = role;
    this.email = email;
    this.profileImage = profileImage;
    this.headerImage = headerImage;
    this.userData = userData;
    this.collection = collection;
    this.social_networks = social_networks;
    this.item_count = item_count;
  }
}
